import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

// interface
import { UserTypes } from "../../../data/chat";
import { STATUS_TYPES } from "../../../constants";
import { Utils } from "helpers/utils";
import UserAvatar from "components/UserAvatar";

interface ChatUserProps {
  user: UserTypes ;
  selectedChat: string | number;
  onSelectChat: (id: number | string) => void;
  is2s?: boolean | null;
  visible?: boolean
}
const ChatUser = ({ user, selectedChat, onSelectChat, is2s = false, visible = true }: ChatUserProps) => {
  //const fullName = `${user.firstName} ${user.lastName}`;
  // console.log('chatuser.user:', user);
  const fullName = is2s ? `${user.firstName} ${user.lastName}` : `ห้องสนทนากับ ${process.env.REACT_APP_COMPANY_ABBR}`;

  const shortName = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;

  const colors = [
    "bg-primary",
    "bg-danger",
    "bg-info",
    "bg-warning",
    "bg-secondary",
    "bg-pink",
    "bg-purple",
  ];
  const [color] = useState(Math.floor(Math.random() * colors.length));
  const isOnline = user.status && user.status === STATUS_TYPES.ACTIVE;
  // const unRead = user.meta && user.meta.unRead;
  const unRead = user?.unreadCount;
  const lastChatTime = user?.lastChatTime;
  const lastChatText = user?.lastChatText;
  const css_unread = localStorage.getItem("lm") == "dark" ? "badge-soft-dark" : "badge-soft-light";

  const isSelectedChat: boolean =
    selectedChat && selectedChat === user.id ? true : false;
  const onClick = () => {
    onSelectChat(user.id);
  };

  const ComponentMain = () => {
    return (
      <li className={classnames({ active: isSelectedChat })} onClick={onClick}>
        <Link to="#" className={classnames({ "unread-msg-user": unRead })}>
          <div className="d-flex align-items-center ">
            <div
              className={classnames(
                "chat-user-img", 
                "align-self-center",
                "me-2",
                "ms-0",
                { online: isOnline }
              )}
            >

              <UserAvatar
                profileImage={user.profileImage}
                bgColor={user.bgColor}
                foreColor={user.foreColor}
                abbrName={user.abbrName}
              />


              {/* {user.profileImage ? (
                <>
                  <img
                    src={user.profileImage}
                    className="rounded-circle avatar-xs"
                    alt=""
                  />
                  {isOnline && <span className="user-status"></span>}
                </>
              ) : (
                <div className="avatar-xs">
                  <span
                    className={classnames(
                      "avatar-title",
                      "rounded-circle",
                      "text-uppercase",
                      "text-white",
                      colors[color]
                    )}
                  >
                    <span className="username">{shortName}</span>
                    <span className="user-status"></span>
                  </span>
                </div>
              )} */}

            </div>
            <div className="overflow-hidden">
              <p className="text-truncate mb-0">{fullName}</p>
              <p className="text-truncate mb-0 last-chat-text">{lastChatText}</p>
            </div>
            <div className="ms-auto text-end">
              <p className="text-truncate mb-0 " >
                <span className={"last-chat-time p-1 "}>{Utils.GetShortDateTimeToShowInChat(lastChatTime, true)}</span>
              </p>
              {unRead && unRead > 0 ? (
                <p className="text-truncate mb-0 unread-badge-p" >
                  <span className={"badge " + css_unread + " unread-badge rounded p-1 "}>{unRead}</span>
                </p>
              ) : null}
            </div>

            {/* {unRead && unRead !== 0 ? ( */}


            {/* {unRead && unRead !== 0 ? (
              <div className="ms-auto">
                <span className={"badge " + css_unread + " rounded p-1"}>
                  {unRead}
                </span>
              </div>
            ) : null} */}
          </div>
        </Link>
      </li >
    )
  }

  return (visible ? (<ComponentMain />) : null);

};

export default ChatUser;
